/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cna_Field_Numbers_PlaceholderInputs */

const en_cna_field_numbers_placeholder = /** @type {(inputs: Cna_Field_Numbers_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. +44 7700 900123`)
};

const ja_cna_field_numbers_placeholder = /** @type {(inputs: Cna_Field_Numbers_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例: +81 90 1234 5678`)
};

const fr_cna_field_numbers_placeholder = /** @type {(inputs: Cna_Field_Numbers_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`p. ex. +33 6 12 34 56 78`)
};

const de_cna_field_numbers_placeholder = /** @type {(inputs: Cna_Field_Numbers_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z. B. +49 151 23456789`)
};

/**
* | output |
* | --- |
* | "e.g. +44 7700 900123" |
*
* @param {Cna_Field_Numbers_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const cna_field_numbers_placeholder = /** @type {((inputs?: Cna_Field_Numbers_PlaceholderInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cna_Field_Numbers_PlaceholderInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cna_field_numbers_placeholder(inputs)
	if (locale === "ja") return ja_cna_field_numbers_placeholder(inputs)
	if (locale === "fr") return fr_cna_field_numbers_placeholder(inputs)
	return de_cna_field_numbers_placeholder(inputs)
});